/** LOADER */
export const SET_LOADER = () => ({ type: "SET_LOADER" })
export const CLEAR_LOADER = () => ({ type: "CLEAR_LOADER" })
